import React from 'react';

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-foreground">View Coach Details</h2>
        <button className="px-4 py-2 bg-card border border-border rounded-md text-foreground hover:bg-background-secondary transition-colors">
          ← Back to Coaches
        </button>
      </div>
      <div className="bg-card border border-card-border rounded-lg p-6 shadow-card">
        <div className="text-center text-foreground-secondary">{message}</div>
      </div>
    </div>
  );
};

export default LoadingState;
